import { render, staticRenderFns } from "./medicalAssetItem.vue?vue&type=template&id=c6c5c880&scoped=true&"
import script from "./medicalAssetItem.vue?vue&type=script&lang=js&"
export * from "./medicalAssetItem.vue?vue&type=script&lang=js&"
import style0 from "./medicalAssetItem.vue?vue&type=style&index=0&id=c6c5c880&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5c880",
  null
  
)

export default component.exports